
// Here is table of all available locales
// https://github.com/TiagoDanin/Locale-Codes
export enum IntlLocale {
    SLOVAK = "sk-SK",
    UNITED_STATES = "en-US",
    UNITED_KINGDOM = "en-GB",
    GERMANY = "de-DE",
    CZHECH = "cs-CZ",
    POLAND = "pl-PL",
    AUSTRIA = "de-AT",
}